module.exports = __webpack_public_path__ + "img/calling__default.379d3981.svg";